module.exports = __webpack_public_path__ + "img/sc_konolfingen_farbig.69bc13ac.png";